import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 20,
	viewBox: "0 0 24 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_612_12315)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 10L5.41 11.41L11 5.83L11 18L13 18L13 5.83L18.59 11.41L20 10L12 2L4 10Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_612_12315",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19.4286,
			height: 24,
			fill: "white",
			transform: "translate(0 19.8096) rotate(-90)"
		})
	}) })]
});
export default SvgUpArrow;
